import React from 'react';
import { Box, Link } from '@mui/material';

// The HPO release behind HPO-derived results, shown where those results are
// (TGCLOUD-1846, decision 6). The HPO licence asks that any HPO file displayed
// publicly carries its date or version; Settings → Terminology carries the full
// statement, and this is the per-surface line for Clinical Insights and
// Suggested Clinical Terms.
//
// `release` comes from the response that produced the results — the release
// that actually answered — not from a separate lookup:
//   { ontology: '2026-09-01', annotations: '2026-09-01',
//     annotationFile: '2026-09-02' }

/** The footer text, or null when there is nothing trustworthy to say. */
export function hpoReleaseText(release) {
  if (!release) return null;
  const ontology = release.ontology || null;
  const annotations = release.annotations || null;
  const main = ontology || annotations;
  if (!main) return null;
  const parts = [`Uses the Human Phenotype Ontology, release ${main}`];
  if (ontology && annotations && annotations !== ontology) {
    parts.push(`annotations release ${annotations}`);
  }
  if (release.annotationFile && release.annotationFile !== main) {
    parts.push(`annotation file ${release.annotationFile}`);
  }
  return `${parts.join(' · ')}.`;
}

export default function HpoReleaseNote({ release, sx }) {
  const text = hpoReleaseText(release);
  if (!text) return null;
  return (
    <Box
      data-testid="hpo-release-note"
      sx={{ fontSize: '.68rem', color: 'text.secondary', px: 1, ...sx }}
    >
      {text}{' '}
      <Link
        href="https://hpo.jax.org/"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        hpo.jax.org
      </Link>
    </Box>
  );
}
